export function errorHandler(type: any, error: any) {
    if (type === "error")
        console.dir(JSON.stringify(error?.message, null, 2));
    else
        console.dir(JSON.stringify(error, null, 2));
}